import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c2b1bae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
import { ref } from 'vue';
import { deleteAppIdAsync, getappIdListAsync } from '@/api/appid';
import { ElMessage, ElMessageBox } from 'element-plus';
import appidDialog from './components/appidDialog';
const pageSize = 10; // 一页数量

export default {
  __name: 'index',
  setup(__props) {
    const appidList = ref([]);
    const loading = ref(false);
    const currentPage = ref(1); // 当前页数
    const total = ref(0);
    /**
     * 获取appid列表
     */
    const getappIdList = async () => {
      loading.value = true;
      try {
        const res = await getappIdListAsync({
          currentPage: currentPage.value,
          pageSize: 10
        });
        appidList.value = res.records;
        total.value = res.total;
        console.log(res.records);
      } catch (error) {
        // console.log(error)
      } finally {
        loading.value = false;
      }
    };
    getappIdList();

    // 页数切换
    const handleCurrentChange = page => {
      currentPage.value = page;
      getappIdList();
    };
    // 添加appid-
    const addGmVisible = ref(false);
    const onAddAppId = () => {
      addGmVisible.value = true;
    };
    // 编辑当前appid
    const currentAppId = ref(null);
    const editAppId = row => {
      currentAppId.value = row;
      onAddAppId();
    };
    // 关闭dialog清除数据
    const clearCurrentAppIdData = () => {
      currentAppId.value = null;
    };
    // 删除appid
    const deleteAppId = row => {
      ElMessageBox.confirm('是否删除该appid', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteAppIdAsync(row.id);
        await getappIdList();
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: onAddAppId
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: appidList.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "tenantName",
            label: "租户名称"
          }), _createVNode(_component_el_table_column, {
            prop: "clinicName",
            label: "诊所名称"
          }), _createVNode(_component_el_table_column, {
            prop: "appId",
            label: "appId"
          }), _createVNode(_component_el_table_column, {
            prop: "appSecret",
            label: "应用密钥"
          }), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "描述"
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => editAppId(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => deleteAppId(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "total"])])]),
        _: 1
      }), _createVNode(_unref(appidDialog), {
        modelValue: addGmVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addGmVisible.value = $event),
        model: currentAppId.value,
        onRefreshData: getappIdList,
        onClearModel: clearCurrentAppIdData
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};